export default {
  id: 'Form',
  code: 'CN',
  text: {
    "This field is required": "此项为必填项",
    "Please enter a valid email": "请输入正确的邮件地址",
    "Please enter a valid phone number": "请输入正确的电话号码",
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/locale.js